export { AonLabel } from "./AonLabel.component";
export { LABEL_STYLE, LABEL_TYPE } from "./consts";
